/**
 * Fondation feature flag gating the « Démonstration » vertical — the sidebar entry, the
 * view, and every route of `DemonstrationModule`. Toggled by an administrator at
 * `/core/features`; the declaration lives in
 * `backend/Parcours.Core/Features/DemonstrationFeature.cs`, and this key must match its
 * `KEY` exactly — a key the catalog does not know reads as `false`, which HIDES the
 * feature rather than exposing it. That is the right default here.
 *
 * Declared `DefaultEnabled = false` on the backend: the vertical GENERATES demonstration
 * data and can purge the database, so an instance opts in explicitly rather than
 * inheriting it. Read through `useSdk().Features.isEnabled(...)`, which is reactive —
 * the value flips once the boot-time flag load resolves, so a view must react to it
 * rather than sample it once at setup.
 *
 * The permissions (`Parcours.Demonstration.*`) still apply on top: the feature says
 * whether the screen exists on this deployment, the permission says who may use it.
 */
export const DEMONSTRATION_FEATURE = 'Demonstration';
